import InventarioFinal from "./InventarioFinal";
export default InventarioFinal;
